import { Label } from "src/data/Label";

// When the hint next to the chat icon shows (XbotHint.tsx), apart from the component so it can be tested alone.

export const HINT_TEXT = `Hi, I'm ${Label.XORBOT}. Ask me about your infrastructure.`;
/** The page is looked at first: the hint comes a moment later. */
export const HINT_DELAY_MS = 3000;
/** How long the hint stays when nobody touches it. */
export const HINT_SHOWN_MS = 15000;

/** A cookie without an expiry: every tab of the browser sees it, and the browser drops it when it closes. */
export const HINT_SHOWN_COOKIE = "xm_xbot_hint";
/** Kept in the browser for good once the chat was opened in it. */
export const CHAT_USED_KEY = "xm-xbot-chat-used";

/**
 * Whether the hint is still to come: once each time the browser opens, until the chat has been opened in this
 * browser, and never over an open chat.
 */
export function hintWanted(chatUsed: boolean, shownSinceBrowserOpened: boolean, chatOpen: boolean): boolean {
  return !chatUsed && !shownSinceBrowserOpened && !chatOpen;
}

/** Whether the page's cookies (document.cookie) hold one of this name. */
export function hasCookie(cookies: string, name: string): boolean {
  return cookies.split(";").some((one) => one.trim().startsWith(`${name}=`));
}
